import { useApp } from "../context/AppContext";

export const useFeatures = () => {
  const { user, organization, _currentProject } = useApp();

  // Check domain from project OR organization
  // Priority: Project Domain -> Organization Domain -> Default
  const domain = organization?.type || "default";

  const userFaaRole = user?.faa_role;

  // Domain Flags
  const isAirplanesDomain = domain === "airplanes";
  const isAerospaceDomain = domain === "aerospace"; // Future use
  const isAutomotiveDomain = domain === "automotive";
  const isNavalDomain = domain === "naval";

  // Feature Gating Logic
  return {
    // FAA Certification Features - STRICTLY GATED to 'airplanes' domain
    faa: {
      enabled: isAirplanesDomain,

      // Workflows
      workflows: true,

      // Admin Review
      adminReview: true,

      // General Features
      classification: isAirplanesDomain,
      drs: isAirplanesDomain,
      gapAnalysis: isAirplanesDomain,
      dashboard: isAirplanesDomain,
    },

    // Automotive Certification Features - GATED to 'automotive' domain
    automotive: {
      enabled: isAutomotiveDomain,

      // Multi-Agency Support (EPA, CARB, NHTSA, FCC)
      multiAgency: isAutomotiveDomain,

      // EPA Pathway Features
      epaPathway: isAutomotiveDomain,
      epaPart1036: isAutomotiveDomain, // Heavy-Duty Engines
      epaPart1037: isAutomotiveDomain, // Heavy-Duty Vehicles

      // CARB Pathway Features
      carbPathway: isAutomotiveDomain,
      carbTitle13: isAutomotiveDomain, // California Standards
      carbExecutiveOrder: isAutomotiveDomain,

      // NHTSA Features
      nhtsaCompliance: isAutomotiveDomain,
      fmvss: isAutomotiveDomain, // Federal Motor Vehicle Safety Standards

      // FCC Features
      fccCompliance: isAutomotiveDomain,
      fccPart15: isAutomotiveDomain, // RF Devices

      // Vehicle Classification
      classification: isAutomotiveDomain,
      gvwrClassification: isAutomotiveDomain,

      // Incomplete Chassis Support
      incompleteChassisWorkflow: isAutomotiveDomain,
      ivdGeneration: isAutomotiveDomain, // Incomplete Vehicle Document
    },

    // Naval Certification Features - GATED to 'naval' domain
    naval: {
      enabled: isNavalDomain,
      uscgCompliance: isNavalDomain,
      imoCompliance: isNavalDomain,
      vesselClassification: isNavalDomain,
      coiApplication: isNavalDomain, // Certificate of Inspection
    },

    // Aerospace Certification Features - GATED to 'aerospace' domain
    aerospace: {
      enabled: isAerospaceDomain,
      faaAstCompliance: isAerospaceDomain,
      launchLicense: isAerospaceDomain,
      rangeCompliance: isAerospaceDomain,
      reusableVehicle: isAerospaceDomain,
    },

    // Core Features (Always available)
    tasks: true,
    documents: true,
    risks: true, // Organization scoped logic handles isolation backend-side

    // Helper to check specific roles
    roles: {
      isOperator: userFaaRole === "operator" || userFaaRole === "both",
      isAdministrator: userFaaRole === "administrator" || userFaaRole === "both",
      isFaaReviewer: userFaaRole === "faa_reviewer",
    },

    // Metadata
    currentDomain: domain,
    currentUserRole: userFaaRole,
  };
};
